export default __webpack_public_path__ + "static/media/thumbnail.954ab0ba.png";